import React from 'react';
import { 
  Typography, 
  CardContent, 
  CardActionArea,
  CardMedia,

} from "@material-ui/core";

const Product = ({ product }) => {
  return (
    <CardActionArea>
      <CardMedia
        component="img"
        alt="Contemplative Reptile"
        height="170"
        image="https://source.unsplash.com/fcnbIO5axMI"
        title={product.name}
      />
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          {product.name}
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Category: {product.brand}
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          Category: {product.category}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Price: &#x20A6; {product.price}
        </Typography>
    </CardContent>
    </CardActionArea>
  );
};
export default Product;
